import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { Customer, JobSite } from '../entities/global/model';
import { crsfNewVM, crsfVM, CustomerdataForExcel, Customer_ContactVM, EqLevelData, EqLevelDataforCustomerContact, EqLevelDataforUserContact, EquipmentTabforCuatomerContact, EquipmentTabVM, JSLVM, JSLVM_USER, UpdateCLRow, UserInfoVMJS } from '../../customer-contact/Models/customer-contact.model';
import { CustomerTab } from '../../customer-contact/Models/customer-details.model';
import { GETImplementVM, Implement, ImplementSerialVM } from '../../interpretation/models/interpretation.model';

@Injectable()
export class CustomerService {
    public RequestResult: boolean = true;
    private ErrorResponse: any;

    constructor(private _http: Http) {
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    /*
        Returns an array of all customers the logged in user has access to
    */
    public getCustomerList(): Observable<Customer[]> {
        let params: URLSearchParams = new URLSearchParams();
        return this._http.get("Api/GETApplication/getCustomerList").share().map(
            (response: Response) => <Customer[]>response.json()).catch(this.handleError);
    }

    
    public AddNewUser_(_form: Customer_ContactVM): Observable<boolean> {
        return this._http.post("api/User/AddNewUsertoCustomer", _form).share().map(
          (response: Response) => <boolean>response.json()).catch(this.handleError);
      }

      public AddNewUsertoJobsite_(cv: JSLVM): Observable<boolean> {
        return this._http.post("api/User/AddNewUsertoJobsite", cv).share().map(
          (response: Response) => <boolean>response.json()).catch(this.handleError);
      }
    
      public getContactToCL(userNo:number): Observable<CustomerTab[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('userNo', "" + userNo);
    
        return this._http.get("api/User/getContactToCL",{ search: params }).share().map(
          (response: Response) => <CustomerTab[]>response.json()).catch(this.handleError);
      }

      public GetJobsitebyId_(customer_auto:number): Observable<crsfVM[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('customer_auto', "" + customer_auto);
    
        return this._http.get("api/User/GetJobsitebyId",{ search: params }).share().map(
          (response: Response) => <crsfVM[]>response.json()).catch(this.handleError);
      }

      
      public GetJobsitebyIdforGrouping(customer_auto:number): Observable<crsfVM[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('customer_auto', "" + customer_auto);
    
        return this._http.get("api/User/GetJobsitebyIdforGrouping",{ search: params }).share().map(
          (response: Response) => <crsfVM[]>response.json()).catch(this.handleError);
      }

      public GetEquipmentbyId(customer_auto:number): Observable<EquipmentTabforCuatomerContact[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('customer_auto', "" + customer_auto);
    
        return this._http.get("api/User/GetEquipmentbyId",{ search: params }).share().map(
          (response: Response) => <EquipmentTabforCuatomerContact[]>response.json()).catch(this.handleError);
      }

      public getCrsfInfo_(): Observable<crsfNewVM[]> {
        return this._http.get("api/User/getCrsfInfo").share().map(
          (response: Response) => <crsfNewVM[]>response.json()).catch(this.handleError);
      }

      public getEquipmentInfo(): Observable<EquipmentTabVM[]> {
        return this._http.get("api/User/getEquipmentInfo").share().map(
          (response: Response) => <EquipmentTabVM[]>response.json()).catch(this.handleError);
      }

      public AddEquipmentdata(cv: EqLevelDataforCustomerContact): Observable<boolean> {
        return this._http.post("api/User/AddEquipmentdata", cv).share().map(
          (response: Response) => <boolean>response.json()).catch(this.handleError);
      }

      // public UpdateConCL(cv: UpdateCLRow): Observable<boolean> {
      //   return this._http.post("api/User/UpdateConCL", cv).share().map(
      //     (response: Response) => <UpdateCLRow>response.json()).catch(this.handleError);
      // }

      public UpdateConCL(contactLsit:CustomerTab[]) {
        return this._http.post('api/User/UpdateConCL', contactLsit).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
      }
   
      public UpdateConJSL(contactLsit:crsfVM[]) {
        return this._http.post('api/User/UpdateConJSL', contactLsit).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
      }

      public UpdateConEL(contactLsit:EquipmentTabforCuatomerContact[]) {
        return this._http.post('api/User/UpdateConEL', contactLsit).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
      }

//delete row
      public DeleteCLdata(contactLsit:CustomerTab[]) {
        return this._http.post('api/User/DeleteCLdata', contactLsit).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
      }
   
      public DeleteJSdata(contactLsit:crsfVM[]) {
        return this._http.post('api/User/DeleteJSdata', contactLsit).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
      }

      public deleteEqData(contactLsit:EquipmentTabforCuatomerContact[]) {
        return this._http.post('api/User/deleteEqData', contactLsit).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
      }

      public getcustomercontactfroexcel(): Observable<CustomerdataForExcel[]> {
        return this._http.get("api/User/getcustomercontactfroexcel").share().map(
          (response: Response) => <CustomerdataForExcel[]>response.json()).catch(this.handleError);
      }


      //user contacts

      public getContactToUser(userNo:number): Observable<CustomerTab[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('userNo', "" + userNo);
    
        return this._http.get("api/User/getContactToUser",{ search: params }).share().map(
          (response: Response) => <CustomerTab[]>response.json()).catch(this.handleError);
      }

      
      public AddNewJobSitetoUser(cv: JSLVM_USER): Observable<boolean> {
        return this._http.post("api/User/AddNewJobSitetoUser", cv).share().map(
          (response: Response) => <boolean>response.json()).catch(this.handleError);
      }

      public GetJobsitebyUser(user_auto:number): Observable<crsfVM[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('user_auto', "" + user_auto);
    
        return this._http.get("api/User/GetJobsitebyUser",{ search: params }).share().map(
          (response: Response) => <crsfVM[]>response.json()).catch(this.handleError);
      }


      public getcustomernamesInfobyUserforgrouping(user_auto:number): Observable<crsfVM[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('user_auto', "" + user_auto);
    
        return this._http.get("api/User/getcustomernamesInfobyUserforgrouping",{ search: params }).share().map(
          (response: Response) => <crsfVM[]>response.json()).catch(this.handleError);
      }

      //equipment
      public AddNewEquipmentstoUser(cv: EqLevelDataforUserContact): Observable<boolean> {
        return this._http.post("api/User/AddNewEquipmentstoUser", cv).share().map(
          (response: Response) => <boolean>response.json()).catch(this.handleError);
      }

      public GetEquipmentbyUserId(user_auto:number): Observable<EquipmentTabforCuatomerContact[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('user_auto', "" + user_auto);
    
        return this._http.get("api/User/GetEquipmentbyUserId",{ search: params }).share().map(
          (response: Response) => <EquipmentTabforCuatomerContact[]>response.json()).catch(this.handleError);
      }

    
      public GetAllImplementDetails(ImplementID:number): Observable<Implement[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ImplementID', "" + ImplementID);
    
        return this._http.get("api/RentalInterp/GetAllImplementDetails",{ search: params }).share().map(
          (response: Response) => <Implement[]>response.json()).catch(this.handleError);
      }
      public GetImplementSerial(EquipmentID:number): Observable<ImplementSerialVM[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('EquipmentID', "" + EquipmentID);
    
        return this._http.get("api/RentalInterp/GetImplementSerial",{ search: params }).share().map(
          (response: Response) => <ImplementSerialVM[]>response.json()).catch(this.handleError);
      }

     
      public GetImplementInspections(ImplementID:number): Observable<GETImplementVM[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ImplementID', "" + ImplementID);
    
        return this._http.get("api/RentalInterp/GetImplementInspections",{ search: params }).share().map(
          (response: Response) => <GETImplementVM[]>response.json()).catch(this.handleError);
      }

      //get user for Customer contact

        // public GetuserDetails_(customerId:number): Observable<UserInfoVMJS[]> {
  //   return this._http.get('api/User/getUserInfo').pipe(catchError(this.handleError));
  // }  
      
      public GetuserDetails_(customerId:number): Observable<UserInfoVMJS[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('customerId', "" + customerId);
    
        return this._http.get("api/User/getUserInfo",{ search: params }).share().map(
          (response: Response) => <UserInfoVMJS[]>response.json()).catch(this.handleError);
      }

      public filterUserInfoJS(jobsiteID:number): Observable<UserInfoVMJS[]> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('jobsiteID', "" + jobsiteID);
    
        return this._http.get("api/User/filterUserInfoJS",{ search: params }).share().map(
          (response: Response) => <UserInfoVMJS[]>response.json()).catch(this.handleError);
      }
      
}
